import { useParams } from "react-router-dom";
import Answers from "../answers/answers";
import PostInfo from "../home/postInfo";
import { useEffect, useState } from "react";
import "../../css/utility/drawer.css";
import RaceDesktopLogo from '../../images/race-icon-cutted.png';
import Login from "../login/login";
import DrawerBackdrop from "../home/drawerBackdrop";
import axios from "axios";
import { getHeadersAuthorization } from '../utilityFunctions/apiheadersauthorization';
import { getApiToken } from '../utilityFunctions/getApiToken';
import Cookies from 'universal-cookie';
import NotFoundPage from '../errorPages/notfoundpage';
import LoginButtonCTA from '../login/loginButtonCTA';

export default function DiscDetailDrawer() {
  const { discId } = useParams();
  const [post, setPost] = useState(null);
  const [cookie, setCookie] = useState(null);

  useEffect( async () => {
    //blocca scroll
    document.body.classList.add('no-scroll');

    const cookies = new Cookies();
    setCookie(cookies.get("data"));

    let token = await getApiToken();
    let conf = {
        headers: getHeadersAuthorization(token)
    };

    let data = {
      id: discId
    };

    axios.post(process.env.REACT_APP_API_HOST + "discussions/getbyid", data, conf)
    .then((response) => {
        let res = 'not_found'
        if(response.data.items.length >= 1){
          res = response.data.items[0];
        }
        setPost(res);
    }).catch((error) => {});
    
  }, [discId]); 

  if(!post) return null;

  if (post === 'not_found'){
    return (
      <NotFoundPage cookie={cookie} />
    );
  }

  if(!cookie){
    return (
      <>
      <Login />
      <div className="drawer-wrapper">
        <div className="drawer-content no-scrollbar">
          <div className="drawer-logo">
            <img src={RaceDesktopLogo} width={'200px'} alt="race-logo"></img>
          </div>
          <div className="disc-cta-buttons">
            <a className="btn btn-primary padd-lr-50" href="/register">Iscriviti</a>
            <LoginButtonCTA className="btn btn-outline-secondary padd-lr-50" />
          </div>
          <div className="section-label">
            <i className="fas fa-comments" style={{ fontSize: '13px' }}></i>
            Discussioni
          </div>
          <h4>{post.title}</h4>
          <p>{post.description}</p>
          <PostInfo user={post.user} created={post.created} />
          <p className="text-muted small mt-3">
            🔒 Accedi o registrati per leggere i commenti e partecipare alla discussione.
          </p>
        </div>
      </div>
      </>
    );
  }

  return (
    <>
    <DrawerBackdrop page={'disc'} />
    <div className="drawer-wrapper">
      <div className="drawer-content logged no-scrollbar">
        <a className="btn btn-sm btn-secondary mb-3" href="/discussions">
          <i className="fas fa-arrow-left mr-1"></i> Vai alla lista
        </a>
        <div className="section-label">
          <i className="fas fa-comments" style={{ fontSize: '13px' }}></i>
          Discussioni
        </div>
        <h4>{post.title}</h4>
        <p>{post.description}</p>
        <PostInfo user={post.user} created={post.created} />
        <Answers id_disc={post.id} />
      </div>
    </div>
    </>
  );
}